export function getSendItemsToShops(bagaz){
    return new Promise(async function(resolve,reject){
        //most likely we will check shops api to see if such item has not been uploaded already
        //if not, then we send the load to shopify
        //as we amend the local db table with what has been send
        bagaz.l=1
        var request=new Request('https://upcscanningapp.azurewebsites.net/api/send_shopify_items', {            
            method:'POST',
            headers: new Headers({'Accept': 'application/json',
            'Content-Type':'application/json'}),
            body:JSON.stringify(bagaz)
            })
        //we make a request
        fetch(request)
        //we get response, in form of json
            .then(response=>response.json())
            .then(response=>{
                console.log('sku returns',response)
                resolve(response)
            })
        })
    }
export function get_check_shops(m_sku){
    return new Promise(async function(resolve,reject){
        let bagaz={m_sku:m_sku}
        var request=new Request('https://upcscanningapp.azurewebsites.net/api/get_shops_details', {            
            method:'POST',
            headers: new Headers({'Accept': 'application/json',
            'Content-Type':'application/json'}),
            body:JSON.stringify(bagaz)
            })
        //we make a request
        fetch(request)
        //we get response, in form of json
            .then(response=>response.json())
            .then(response=>{
                //console.log('sku returns',response)
                resolve(response)
            })
        })
    }
export function get_shops_variant_quantity(bagaz){
    return new Promise(async function(resolve,reject){
        //most likely we will check shops api to see if such item has not been uploaded already
        //if not, then we send the load to shopify
        //as we amend the local db table with what has been send
        bagaz.l=1
        var request=new Request('https://upcscanningapp.azurewebsites.net/api/get_shopify_variant_quantity', {            
            method:'POST',
            headers: new Headers({'Accept': 'application/json',
            'Content-Type':'application/json'}),
            body:JSON.stringify(bagaz)
            })
        //we make a request
        fetch(request)
        //we get response, in form of json
            .then(response=>response.json())
            .then(response=>{
                console.log('sku returns',response)
                resolve(response)
            })
        })
    }
    